<template>
  <div>
    <v-avatar size="20" color="var(--v-resGrey-lighten1)">
      <v-icon dense color="var(--v-resGrey-darken1)">
        mdi-approximately-equal
      </v-icon>
    </v-avatar>
   
    <span>{{ params.contents }}</span>

  </div>
</template>

<script>
  export default {
    name: 'AveragedReadonlyCell',
  }
</script>

<style scoped lang="scss">
</style>
